import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';

import {AppComponent} from './app.component';
import {HelpComponent} from './help/help.component';
import {BuscaComponent} from './help/busca/busca.component';
import {ListaComponent} from './help/lista/lista.component';
import {HelpService} from './help/help.service';

import {appRouting} from './app.routing';
import {NotFoundComponent} from './not-found/not-found.component';
import {FormComponent} from './help/form/form.component';
import {ViewComponent} from './help/view/view.component';
import {helpRouting} from './help/help.routing';
import { UppercaseDirective } from './uppercase.directive';

@NgModule({
  declarations: [
    AppComponent,
    HelpComponent,
    BuscaComponent,
    ListaComponent,
    NotFoundComponent,
    FormComponent,
    ViewComponent,
    UppercaseDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BrowserModule,
    helpRouting,
    appRouting
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}, HelpService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts